import { useSnackbar } from "notistack";
import type { FC } from "react";
import { getOrderPdf } from "../../api/api";
import DownloadFileButton from "../components/downloadFileButton/DownloadFileButton";
import type { OrderType } from "./orderTypes";

interface Props {
  readonly orderId: string;
  readonly orderType?: OrderType;
  readonly filename: string;
}

const DownloadOrderPdfButton: FC<Props> = ({ orderId, orderType, filename }) => {
  const { enqueueSnackbar } = useSnackbar();
  const options = [
    { name: "Bez cen opcji", apiDefinition: () => getOrderPdf(orderId, false) },
    { name: "Z cenami opcji", apiDefinition: () => getOrderPdf(orderId, true), disabled: orderType === "PACKAGE" },
  ];
  return (
    <DownloadFileButton
      variant="outlined"
      color="inherit"
      sx={{ borderRadius: 2 }}
      options={options}
      onError={() => enqueueSnackbar("Nie udało się pobrać pliku PDF z zamówieniem", { variant: "error" })}
      filename={filename}
    />
  );
};

export default DownloadOrderPdfButton;
